import { render, staticRenderFns } from "./AgreementTeacher.vue?vue&type=template&id=3509fc96"
import script from "../../services/teacher/agreement-teacher.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/agreement-teacher.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/signup-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports